import { ApiState } from "infrastructure/api";
import { PER_PAGE_SIZE } from "consts/transactions";
import useFetchFeatureResource, { type UseFetchFeatureResourceArg } from "hooks/useFetchFeatureResource";
import { changePaymentMethodsLoadingState, changePaymentMethodsSlice } from "./slice";

export const useFetchPaymentMethods = (settings: Pick<UseFetchFeatureResourceArg, 'resourceRequest'>) => (
    useFetchFeatureResource({
        ...settings,
        shouldFetchAll: true,
        perPage: PER_PAGE_SIZE,
        changeLoadingState: changePaymentMethodsLoadingState,
        changeSlice: changePaymentMethodsSlice,
        condition: getState => ![
            ApiState.Succeeded,
            ApiState.Pending
        ].includes(getState().paymentMethods.paymentMethodsLoadingState)
    })
);

export default useFetchPaymentMethods;
